// extracted by mini-css-extract-plugin
export default {"block":"block_block__31Mb1","header":"block_header__TfYHt","children":"block_children__dL3+o"};